import { isEmpty } from 'lodash';
import moment from 'moment';

import { formatDate } from 'lib/helpers/utility';

import formatRecurrenceObject from './formatRecurrenceObject';

export default function (changedValues, values, considerRecurrenceChange = false) {
  let dirtyValues = { ...changedValues };

  const recurrenceFields = [
    'end_date',
    'repeat_event',
    'repeat_every',
    'ends_type',
    'repeat_on',
    'events',
    'weekdays'
  ];
  // eslint-disable-next-line no-prototype-builtins
  const isRecurrenceChanged = recurrenceFields.some((field) => dirtyValues.hasOwnProperty(field));
  if (isRecurrenceChanged || considerRecurrenceChange) {
    const isBaseAppointment = values?.is_base_appointment;

    const isRecurrenceDeleted = recurrenceFields.every((field) => !dirtyValues[field]);
    if (isRecurrenceDeleted && !considerRecurrenceChange) {
      dirtyValues.recurrence = {
        delete: true
      };
    } else {
      const formattedRecurrence = formatRecurrenceObject(values);
      dirtyValues = { ...dirtyValues };
      dirtyValues.recurrence = {};
      dirtyValues.recurrence.changes = {
        //store the recurrence fields from the dirtyValu±es those are changed
        ...recurrenceFields.reduce((acc, field) => {
          if (dirtyValues[field]) {
            acc[field] = formattedRecurrence[field];
          }
          return acc;
        }, {})
      };

      if (isBaseAppointment) {
        dirtyValues.recurrence.base_appointment = true;
      } else {
        dirtyValues.recurrence.base_appointment = false;
        dirtyValues.recurrence.base_end_date = moment(values.starts_at).subtract(1, 'day').toDate();

        if (
          (isEmpty(dirtyValues.recurrence.changes) || !dirtyValues.recurrence.changes) &&
          considerRecurrenceChange
        ) {
          dirtyValues.recurrence.changes = {
            end_date: formatDate(values.end_date),
            ends_type: 'on_date',
            events: null
          };
        }

        if (!dirtyValues.ends_at || !dirtyValues.starts_at) {
          dirtyValues.starts_at = values.starts_at;
          dirtyValues.ends_at = values.ends_at;
        }
      }
    }

    recurrenceFields.forEach((field) => delete dirtyValues[field]);
  }

  if (dirtyValues.ends_at && considerRecurrenceChange) {
    dirtyValues.duration = moment(dirtyValues.ends_at).diff(moment(values.starts_at), 'minutes');
  }

  delete dirtyValues.end_date;
  return { appointment_changes: dirtyValues, isRecurrenceChanged };
}
